@switch (step) {
  @case (Step.One) {
    <rt-sms-activation-step-1
      (cancel)="cancel()"
      (goNext)="goToStepTwo($event)"
    ></rt-sms-activation-step-1>
  }
  @case (Step.Two) {
    <rt-sms-activation-step-2
      [phoneNumber]="phoneNumber"
      (activated)="activated()"
      (cancel)="cancel()"
      (goBack)="changeStep(Step.One)"
    ></rt-sms-activation-step-2>
  }
}
